import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import "../../../modals/add-equipment-template/add-equipment-template.scss";
// import { SaveUpdateEquipmentTemplate } from "../../../api";
import Loader from "../../../loader/loader";
import SelectDropDown from "../../../shared/drop-down/drop-down";

import * as yup from "yup";
const schema = yup.object({
    gateway_option: yup.string().trim().required("* This filed is required"),
    equipment_option: yup.string().trim().required("* Equipment is required"),
    gateway_type: yup
        .string()
        .trim()
        .nullable()
        .when(["equipment_option"], (option, schema) => {
            return option == "gateway"
                ? schema.required("* Gateway type required")
                : schema;
        }),
    terminal_type: yup
        .string()
        .trim()
        .nullable()
        .when(["equipment_option"], (option, schema) => {
            return option == "terminal"
                ? schema.required("* Terminal type required")
                : schema;
        }),
});
const GatewayTypes = [
    {
        value: "authorize_net",
        label: "Authorize.net",
    },
    {
        value: "nmi",
        label: "NMI",
    },
    {
        value: "usa_e_pay",
        label: "USAePay",
    },
    {
        value: "paysley",
        label: "Paysley",
    },
    {
        value: "VAR",
        label: "VAR",
    },
];

const TerminalTypes = [
    {
        value: "pax-a920",
        label: "Pax A920",
    },
    {
        value: "pax-a80",
        label: "Pax A80",
    },
    {
        value: "dejavoo-z9",
        label: "Dejavoo z9",
    },
    {
        value: "dejavoo-qd4",
        label: "Dejavoo QD4",
    },
    {
        value: "dejavoo-qd2",
        label: "Dejavoo QD2",
    },
    {
        value: "dejavoo-z8",
        label: "Dejavoo z8",
    },
    {
        value: "bbpos",
        label: "BBPOS 3-in-1 Bluetooth Card Reader",
    },
    {
        value: "payanywhere-smart-terminal-mini",
        label: "Payanywhere Smart Terminal Mini",
    },
    {
        value: "payanywhere-smart-flex",
        label: "Payanywhere Smart Flex",
    },
    {
        value: "payanywhere-smart-pos",
        label: "Payanywhere Smart POS+",
    },
    {
        value: "payanywhere-smart-terminal",
        label: "PayAnywhere Smart Terminal",
    },
    {
        value: "payanywhere-smart-keypad",
        label: "PayAnywhere Smart Keypad",
    },
    {
        value: "payanywhere-mobile-card-reader",
        label: "PayAnywhere 3-in-1 Mobile Card Reader",
    },
    {
        value: "VAR",
        label: "VAR",
    },
    {
        value: "VL100",
        label: "VL100 (Standard Terminal)",
    },
    {
        value: "VL110",
        label: "VL110 (Wireless Terminal)",
    },
    {
        value: "VL500",
        label: "VL500 (Pro Terminal)",
    },
    {
        value: "VL300",
        label: "VL300 (Pin Pad)",
    },
];

class EditEquipmentCreateApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedTemplate ? true : false,
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            formData: {
                gateway_option: props.selectedTemplate
                    ? props.selectedTemplate.gateway_option
                    : "",
                equipment_option: props.selectedTemplate
                    ? props.selectedTemplate.equipment_option
                    : "",
                equipment_type: props.selectedTemplate
                    ? props.selectedTemplate.equipment_type
                    : "",
                merchant_dba_address: props.selectedTemplate
                    ? props.selectedTemplate.merchant_dba_address
                    : "",
                template_name: props.selectedTemplateName
                    ? props.selectedTemplateName
                    : "",
                gateway_type: null,
                terminal_type: null,
            },
            errors: [],
            gateway_type: props?.selectedTemplate?.gateway_name,
            terminal_type: props?.selectedTemplate?.terminal_name,
        };
    }

    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;

        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    // add organization data
    handleAddTemplate(evt) {
        // this.setState({ show_spinner: true });

        const fromData = this.state.formData;

        if (
            fromData.equipment_option === "terminal" &&
            fromData.gateway_option === "paymentcloud_provided"
        ) {
            fromData.merchant_dba_address = fromData.merchant_dba_address;
        } else {
            fromData.merchant_dba_address = "";
        }
        if (
            fromData.equipment_option == "terminal" ||
            fromData.equipment_option == "gateway"
        ) {
            fromData.equipment_type = fromData.equipment_type;
        } else {
            fromData.equipment_type = "";
        }

        let templateOptions = {
            gateway_option: fromData.gateway_option,
            equipment_option: fromData.equipment_option,
            equipment_type: fromData.equipment_type,
            merchant_dba_address: fromData.merchant_dba_address,
            gateway_name: fromData.gateway_type,
            terminal_name: fromData.terminal_type,
        };

        this.props.setData(templateOptions);
    }

    handleGatewayChange = (e) => {
        this.setState({
            formData: {
                ...this.state.formData,
                gateway_type: e.value,
                terminal_type: null,
            },
            gateway_type: e.value,
            errors: [],
        });
    };

    handleTerminalChange = (e) => {
        this.setState({
            formData: {
                ...this.state.formData,
                terminal_type: e.value,
                gateway_type: null,
            },
            terminal_type: e.value,
            errors: [],
        });
    };

    render() {
        const {
            isEdit,
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
        } = this.state;
        return (
            <ReactModal isOpen={this.props.show} className="add-template-modal">
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit Template" : "Add Template"}
                    </h4>
                </div>
                <div
                    onClick={() => this.props.handleCloseModel()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleAddTemplate(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="add-template-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="pri-heading1 mg-bottom-15">
                                            Equipment provided by
                                        </div>
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="gateway_option"
                                                    value="paymentcloud_provided"
                                                    checked={
                                                        values.gateway_option ===
                                                        "paymentcloud_provided"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    PaymentCloud
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="gateway_option"
                                                    value="merchant_provided"
                                                    checked={
                                                        values.gateway_option ===
                                                        "merchant_provided"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Agent
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.gateway_option}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="pri-heading1 mg-bottom-15">
                                            Select your equipment type
                                        </div>
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="equipment_option"
                                                    value="terminal"
                                                    checked={
                                                        values.equipment_option ===
                                                        "terminal"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Terminal
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="equipment_option"
                                                    value="gateway"
                                                    checked={
                                                        values.equipment_option ===
                                                        "gateway"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Gateway
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.equipment_option}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {values.equipment_option == "gateway" && (
                                        <Form.Group
                                            as={Col}
                                            xs={12}
                                            className="px-3"
                                        >
                                            <SelectDropDown
                                                options={GatewayTypes}
                                                name="gateway_type"
                                                placeholder="Select Gateway type"
                                                value={this.state.gateway_type}
                                                handleChange={(selected) => {
                                                    this.handleGatewayChange(
                                                        selected,
                                                    );
                                                }}
                                                touched={touched.gateway_type}
                                                errors={errors.gateway_type}
                                            />

                                            <label className="modal-lab">
                                                Gateway Type
                                            </label>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.gateway_type}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    )}

                                    {values.equipment_option == "terminal" && (
                                        <Form.Group
                                            as={Col}
                                            xs={12}
                                            className="px-3"
                                        >
                                            <SelectDropDown
                                                options={TerminalTypes}
                                                name="terminal_type"
                                                placeholder="Select Terminal"
                                                value={this.state.terminal_type}
                                                handleChange={(selected) => {
                                                    this.handleTerminalChange(
                                                        selected,
                                                    );
                                                }}
                                                touched={touched.terminal_type}
                                                errors={errors.terminal_type}
                                            />

                                            <label className="modal-lab">
                                                Terminal Type
                                            </label>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {" "}
                                                {errors.terminal_type}{" "}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    )}
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message text-center">{errorMessage}</p>
                <div className="modal-footer">
                    <div className="button-twoc">
                        <button
                            form="add-template-form"
                            type="submit"
                            className="btn confirm-button"
                        >
                            {" "}
                            {isEdit ? "Update" : "Add"}{" "}
                        </button>
                        <button
                            className="btn cancel-button"
                            onClick={() => this.props.handleCloseModel()}
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default EditEquipmentCreateApp;
